module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_9006.ef3405ce.png";